import React, { useEffect, useState } from 'react'
import { Card, Avatar, Button, Form, Input, message } from 'antd'

import { Link, useNavigate } from 'react-router-dom'
import { getAccountInfoAPI, editAccountPasswordAPI } from '@/apis/user'
import { sendPhoneCodeAPI } from '@/apis/common'
import { checkLogin, checkPhone } from '@/utils'
import styles from './account.module.scss'

let Interval = null
export default function Index() {
  const navigate = useNavigate()
  const [accountInfo, setAccountInfo] = useState({})
  const [passwordPopupVisible, setPasswordPopupVisible] = useState(false)
  const [formData, setFormData] = useState({
    smscode: '',
    newPassword: '',
    newPassword2: ''
  })
  const [count, setCount] = useState(60)
  const [intervalStatus, setIntervalStatus] = useState(false)
  //  获取账号详情
  const getAccountInfo = async () => {
    const res = await getAccountInfoAPI()
    if (res.success === true) {
      setAccountInfo(res.result)
    }
  }
  //  显示/隐藏修改密码弹窗
  const showPasswordPopup = () => {
    formData.smscode = ''
    formData.newPassword = ''
    formData.newPassword2 = ''

    setFormData({
      ...formData,
      smscode: '',
      newPassword: '',
      newPassword2: '',
    })
    setPasswordPopupVisible(!passwordPopupVisible)
  }
  const sendCodeMsg = () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    if(!checkPhone(accountInfo.phone)) {
      message.error('手机号格式不正确')
      return
    }
    
    sendPhoneCodeAPI({ phone: accountInfo.phone }).then(res => {
      if (res.success === true) {
        if(res.message === '验证码发送失败') {
          message.error(res.message)
        } else {
          message.success('发送成功')
          let timer = 60
          setIntervalStatus(true)
          setCount(timer)
          Interval = setInterval(() => {
            timer--
            setCount(timer)
            if (timer <= 0) {
              clearInterval(Interval)
              setIntervalStatus(false)
            }
          }, 1000)
        }
      }
    })
  }
  const changeForm = e => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    if('smscode' in e) {
      setFormData({
        ...formData,
        smscode: e.smscode
      })
    } else if('newPassword' in e) {
      setFormData({
        ...formData,
        newPassword: e.newPassword
      })
    } else if('newPassword2' in e) {
      setFormData({
        ...formData,
        newPassword2: e.newPassword2
      })
    }
  }
  const submitForm = async values => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
    }
    setFormData({
      ...formData,
      smscode: values.smscode,
      newPassword: values.newPassword,
      newPassword2: values.newPassword2,
    })
    if(values.smscode.length !== 6) {
      message.error('验证码格式不正确')
      return
    }
    if(values.newPassword.length < 6 || values.newPassword.length > 12) {
      message.error('密码设置6-12位')
      return
    }
    if(values.newPassword !== values.newPassword2) {
      message.error('两次密码输入不一致')
      return
    }
      console.log('%c [ formData ]-98', 'font-size:13px; background:#2dcae5; color:#71ffff;', formData)
    let params = {
      phone: accountInfo.phone,
      smscode: values.smscode,
      newPassword: values.newPassword,
    }
    const res = await editAccountPasswordAPI(params)
    if (res.success === true) {
      message.success('密码设置成功')
      accountInfo.password = true
      setAccountInfo({
        ...accountInfo,
        password: true
      })
      setPasswordPopupVisible(false)
    } else {
      message.error(res.message)
    }
  }

  useEffect(() => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    getAccountInfo()
  }, [])

  return (
    <div>
      <div className="pageTitle">Hi，{decodeURIComponent(accountInfo.userName)}</div>
      <Card className="card" title="账户余额">
        <div className="flex align-items border-bottom line-height-24 padding-bottom-24 font-size16">
          <div className={[styles['label'], 'gray'].join(' ')}>余额</div>
          <div className="flex-1 font-weight-600">{ accountInfo.balance }元</div>
          <Link target="_blank" to="/managecenter/account/balancelist" className="color-576b95">明细</Link>
        </div>
      </Card>
      <Card className="card" title="账号信息">
        <div className="flex align-items border-bottom line-height-24 padding-bottom-24 font-size16">
          <div className={[styles['label'], 'gray'].join(' ')}>昵称</div>
          <div className="flex-1 font-weight-600">{decodeURIComponent(accountInfo.userName)}</div>
          {/* <Link target="_blank" to="" className="color-576b95">修改</Link> */}
        </div>
        <div className="flex align-items border-bottom padding-top-24 padding-bottom-24 font-size16">
          <div className={[styles['label'], 'gray'].join(' ')}>头像</div>
          <div className="flex-1 font-weight-600">
            <Avatar shape="square" size={48} draggable={false} src={accountInfo.avatar ? accountInfo.avatar + '?x-oss-process=image/resize,w_24,m_lfit' : '/images/avatar.png'} />
          </div>
          {/* <Link target="_blank" to="" className="color-576b95">修改</Link> */}
        </div>
        <div className="flex align-items border-bottom line-height-24 padding-top-24 padding-bottom-24 font-size16">
          <div className={[styles['label'], 'gray'].join(' ')}>手机</div>
          <div className="flex-1 font-weight-600">{ accountInfo.phone }</div>
          {/* <Link target="_blank" to="" className="color-576b95">更换</Link> */}
        </div>
        <div className="flex align-items border-bottom line-height-24 padding-top-24 padding-bottom-24 font-size16">
          <div className={[styles['label'], 'gray'].join(' ')}>密码</div>
          <div className="flex-1 font-weight-600">{ accountInfo.password ? '已设置' : '-' }</div>
          <Button type="link" onClick={() => showPasswordPopup()} className="color-576b95">{accountInfo.password ? '修改' : '设置'}</Button>

        </div>
      </Card>
      <div className={passwordPopupVisible ? 'popup flex-center' : 'popup flex-center none'}>
        <div className="popup-close" onClick={() => showPasswordPopup()}></div>
        <div className="popup-page" style={{width: '450px'}}>
          <div className="title">{accountInfo.password ? '修改' : '设置'}密码</div>
          <Form initialValues={formData} onValuesChange={changeForm} onFinish={submitForm}>
            <div className='margin-top-32 margin-bottom-24 font-size16'>手机号：{accountInfo.phone}</div>
            <Form.Item name="smscode">
              <div className={[styles['phone'], 'flex', 'align-items', 'bg-fafafa'].join(' ')}>
                <Input placeholder="验证码" value={formData.smscode} className={[styles['phoneInput'], 'flex-1', 'bg-fafafa'].join(' ')} />
                <div className={[styles['codeBtn'], 'font-size16', 'green', 'cursor-pointer'].join(' ')} onClick={sendCodeMsg}>{intervalStatus ? count + '秒后重新发送' : '发送验证码'}</div>
              </div>
            </Form.Item>
            <Form.Item name="newPassword">
              <Input.Password value={formData.newPassword} placeholder="新密码，6-12位" className="bg-fafafa padding-top-10 padding-bottom-10" />
            </Form.Item>
            <Form.Item name="newPassword2">
              <Input.Password value={formData.newPassword2} placeholder="确认新密码" className="bg-fafafa padding-top-10 padding-bottom-10" />
            </Form.Item>
            <Form.Item>
              <Button block size="large" htmlType="submit" className={[styles['submitBtn'], 'bg-green', 'white', 'padding-top-10', 'padding-bottom-10', 'font-size16', 'line-height-24'].join(' ')}>
                提交
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  )
}
